// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/portal_common.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * @generated from enum spwn.account.v1.PortalFanRole
 */
export var PortalFanRole;
(function (PortalFanRole) {
    /**
     * @generated from enum value: PORTAL_FAN_ROLE_UNSPECIFIED = 0;
     */
    PortalFanRole[PortalFanRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PORTAL_FAN_ROLE_CREATOR = 1;
     */
    PortalFanRole[PortalFanRole["CREATOR"] = 1] = "CREATOR";
    /**
     * @generated from enum value: PORTAL_FAN_ROLE_OPERATOR = 2;
     */
    PortalFanRole[PortalFanRole["OPERATOR"] = 2] = "OPERATOR";
})(PortalFanRole || (PortalFanRole = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalFanRole)
proto3.util.setEnumType(PortalFanRole, "spwn.account.v1.PortalFanRole", [
    { no: 0, name: "PORTAL_FAN_ROLE_UNSPECIFIED" },
    { no: 1, name: "PORTAL_FAN_ROLE_CREATOR" },
    { no: 2, name: "PORTAL_FAN_ROLE_OPERATOR" },
]);
/**
 * fan, creator, operatorに寄らない共通のユーザー情報
 *
 * @generated from message spwn.account.v1.PortalUser
 */
export class PortalUser extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalUser().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalUser().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalUser().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalUser, a, b);
    }
}
PortalUser.runtime = proto3;
PortalUser.typeName = "spwn.account.v1.PortalUser";
PortalUser.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalFan
 */
export class PortalFan extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        /**
         * @generated from field: spwn.account.v1.PortalFanRole role = 5;
         */
        this.role = PortalFanRole.UNSPECIFIED;
        /**
         * ファンが所属しているテナント
         *
         * @generated from field: repeated spwn.account.v1.PortalTenantCore belonging_tenants = 6;
         */
        this.belongingTenants = [];
        /**
         * 権限があるブランド
         *
         * @generated from field: repeated spwn.account.v1.PortalBrandCore authorized_brands = 7;
         */
        this.authorizedBrands = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalFan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalFan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalFan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalFan, a, b);
    }
}
PortalFan.runtime = proto3;
PortalFan.typeName = "spwn.account.v1.PortalFan";
PortalFan.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "role", kind: "enum", T: proto3.getEnumType(PortalFanRole) },
    { no: 6, name: "belonging_tenants", kind: "message", T: PortalTenantCore, repeated: true },
    { no: 7, name: "authorized_brands", kind: "message", T: PortalBrandCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.PortalBrand
 */
export class PortalBrand extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 2;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 4;
         */
        this.slug = "";
        /**
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * @generated from field: string icon_thumbnail = 6;
         */
        this.iconThumbnail = "";
        /**
         * @generated from field: string cover_thumbnail = 7;
         */
        this.coverThumbnail = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalBrand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalBrand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalBrand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalBrand, a, b);
    }
}
PortalBrand.runtime = proto3;
PortalBrand.typeName = "spwn.account.v1.PortalBrand";
PortalBrand.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "cover_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "belonging_tenant", kind: "message", T: PortalTenantCore },
]);
/**
 * @generated from message spwn.account.v1.PortalBrandCore
 */
export class PortalBrandCore extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 2;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 4;
         */
        this.slug = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalBrandCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalBrandCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalBrandCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalBrandCore, a, b);
    }
}
PortalBrandCore.runtime = proto3;
PortalBrandCore.typeName = "spwn.account.v1.PortalBrandCore";
PortalBrandCore.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalTenant
 */
export class PortalTenant extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string tenant_firestore_id = 2;
         */
        this.tenantFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 所属しているクリエイター情報は公開しない (owned_creators)
         *
         * @generated from field: repeated spwn.account.v1.PortalBrandCore owned_brands = 5;
         */
        this.ownedBrands = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalTenant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalTenant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalTenant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalTenant, a, b);
    }
}
PortalTenant.runtime = proto3;
PortalTenant.typeName = "spwn.account.v1.PortalTenant";
PortalTenant.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "owned_brands", kind: "message", T: PortalBrandCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.PortalTenantCore
 */
export class PortalTenantCore extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string tenant_firestore_id = 2;
         */
        this.tenantFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalTenantCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalTenantCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalTenantCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalTenantCore, a, b);
    }
}
PortalTenantCore.runtime = proto3;
PortalTenantCore.typeName = "spwn.account.v1.PortalTenantCore";
PortalTenantCore.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalDMUser
 */
export class PortalDMUser extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string avatar_url = 3;
         */
        this.avatarUrl = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalDMUser().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalDMUser().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalDMUser().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalDMUser, a, b);
    }
}
PortalDMUser.runtime = proto3;
PortalDMUser.typeName = "spwn.account.v1.PortalDMUser";
PortalDMUser.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalDMBrand
 */
export class PortalDMBrand extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 2;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string avatar_url = 4;
         */
        this.avatarUrl = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalDMBrand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalDMBrand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalDMBrand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalDMBrand, a, b);
    }
}
PortalDMBrand.runtime = proto3;
PortalDMBrand.typeName = "spwn.account.v1.PortalDMBrand";
PortalDMBrand.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountSubscribedPlan
 */
export class PortalAccountSubscribedPlan extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: int64 started_at = 3;
         */
        this.startedAt = protoInt64.zero;
        /**
         * @generated from field: string thumbnail = 4;
         */
        this.thumbnail = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountSubscribedPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountSubscribedPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountSubscribedPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountSubscribedPlan, a, b);
    }
}
PortalAccountSubscribedPlan.runtime = proto3;
PortalAccountSubscribedPlan.typeName = "spwn.account.v1.PortalAccountSubscribedPlan";
PortalAccountSubscribedPlan.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountPurchasedGoods
 */
export class PortalAccountPurchasedGoods extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountPurchasedGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountPurchasedGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountPurchasedGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountPurchasedGoods, a, b);
    }
}
PortalAccountPurchasedGoods.runtime = proto3;
PortalAccountPurchasedGoods.typeName = "spwn.account.v1.PortalAccountPurchasedGoods";
PortalAccountPurchasedGoods.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "purchased_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountPurchasedEventTickets
 */
export class PortalAccountPurchasedEventTickets extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_name = 2;
         */
        this.eventName = "";
        /**
         * @generated from field: string ticket_name = 5;
         */
        this.ticketName = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountPurchasedEventTickets().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountPurchasedEventTickets().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountPurchasedEventTickets().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountPurchasedEventTickets, a, b);
    }
}
PortalAccountPurchasedEventTickets.runtime = proto3;
PortalAccountPurchasedEventTickets.typeName = "spwn.account.v1.PortalAccountPurchasedEventTickets";
PortalAccountPurchasedEventTickets.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "event_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ticket_purchased_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * コアファン (現在プランに加入している or グッズを購入したことがある or イベントチケットを購入したことがある)
 *
 * @generated from message spwn.account.v1.PortalAccountCoreFan
 */
export class PortalAccountCoreFan extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.PortalAccountSubscribedPlan subscribed_plans = 2;
         */
        this.subscribedPlans = [];
        /**
         * @generated from field: repeated spwn.account.v1.PortalAccountPurchasedGoods purchased_goods = 3;
         */
        this.purchasedGoods = [];
        /**
         * @generated from field: repeated spwn.account.v1.PortalAccountPurchasedEventTickets purchased_tickets = 4;
         */
        this.purchasedTickets = [];
        /**
         * @generated from field: string memo = 5;
         */
        this.memo = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountCoreFan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountCoreFan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountCoreFan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountCoreFan, a, b);
    }
}
PortalAccountCoreFan.runtime = proto3;
PortalAccountCoreFan.typeName = "spwn.account.v1.PortalAccountCoreFan";
PortalAccountCoreFan.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: PortalUser },
    { no: 2, name: "subscribed_plans", kind: "message", T: PortalAccountSubscribedPlan, repeated: true },
    { no: 3, name: "purchased_goods", kind: "message", T: PortalAccountPurchasedGoods, repeated: true },
    { no: 4, name: "purchased_tickets", kind: "message", T: PortalAccountPurchasedEventTickets, repeated: true },
    { no: 5, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=portal_common_pb.js.map